module.exports = __webpack_public_path__ + "img/logo2.6dcfba54.png";